export default __webpack_public_path__ + "static/media/H1001a.5ea393d2.mp3";